import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken, TOKEN_KEY, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // null = checking, false = anon, object = logged in
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setUser(false);
      return null;
    }
    try {
      const res = await api.get("/auth/me");
      setUser(res.data.user);
      return res.data.user;
    } catch (e) {
      setAuthToken(null);
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    try {
      const res = await api.post("/auth/login", { email, password });
      setAuthToken(res.data.access_token);
      setUser(res.data.user);
      return { ok: true, user: res.data.user };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const register = async (name, email, password) => {
    try {
      const res = await api.post("/auth/register", { name, email, password });
      setAuthToken(res.data.access_token);
      setUser(res.data.user);
      return { ok: true, user: res.data.user };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const logout = () => {
    setAuthToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
